import { ReactElement, useEffect } from 'react';
import { useRouter } from '@abyss/web/hooks/useRouter';
import { UserService } from '@src/api/common/UserService';

interface AuthGuardProps {
  children: ReactElement;
  requireAuth?: boolean;
}

export const AuthenticationGuard = ({
  children,
  requireAuth = true,
}: AuthGuardProps) => {
  const { navigate, getLocation } = useRouter();
  const location = getLocation();
  const currentPath = location?.pathname || '';
  const isLoggedIn = UserService.IsLoggedIn();
  const callbackPaths = ['/sso', '/getToken', '/getAToken'];
  const isCallbackPath = callbackPaths.includes(currentPath);
  const shouldHideWhileRedirect =
    (requireAuth && !isLoggedIn) || (!requireAuth && isLoggedIn && !isCallbackPath);

  useEffect(() => {
    if (requireAuth && !isLoggedIn) {
      navigate('/login');
    } else if (!requireAuth && isLoggedIn && !isCallbackPath) {
      navigate('/route-tool/upload');
    }
  }, [currentPath, isCallbackPath, isLoggedIn, navigate, requireAuth]);

  if (shouldHideWhileRedirect) {
    return <></>;
  }

  return children;
};
